import { Badge } from "@common/index";
import { ComponentColor, ComponentSize } from "@common/types";

// "A resale certificate was uploaded after the last review" (E12-S5 / #240).
// Shared by the clients list (per org) and the client detail (per location);
// POST locations/{id}/cert/acknowledge clears it.
export const NewCertBadge = () => (
    <Badge
        color={ComponentColor.Warning}
        size={ComponentSize.SM}
        title="A resale certificate was uploaded after the last review"
    >
        New cert
    </Badge>
);
